import React from 'react'
import styles from './FeedbackBlock.module.scss'


const FeedbackBlock = (props) => {

    const {status, variant, caption, overlay, className, children} = props
    const feedbackStatus = (status) => {

        switch(status){
            case 'intro': return styles.intro
            case 'failed': return styles.failed
            case 'success': return styles.success
            case 'warning': return styles.warning
            case 'none': return styles.none
            case 'default': return styles.default
            default: return styles.none
        }

    }
    const setVariant = (variant) => {
        switch(variant){
            case 'none': return styles.none
            case 'wide': return styles.wide
            case 'popup': return styles.popup
            case 'fill': return styles.fill
        }
    }
    return (

        <div className={`feedback-block ${styles.container} ${setVariant(variant)}  ${feedbackStatus(status)} ${className} `}> 
            {caption && status && 
                <span className={`status ${styles.caption} ${feedbackStatus(status)}`}>
                    {caption}
                </span>
            }

            {/* Adds an overlayed feedback */}
            {overlay && <div className={`overlay ${styles.overlay}`}>
                { overlay }
            </div> }

           {children}
           
        </div>
    )
}

export default FeedbackBlock